import React from 'react';
import './PickSeatAutomatic.scss';
import { Divider } from 'antd';
import Button from 'Components/Shared/Button/Button';
import Checkbox from 'Components/Shared/Checkbox/Checkbox';
import SeatItem from 'Components/PickSeatAutomatic/SeatItem';
import PickTime from 'Components/PickSeatAutomatic/PickTime';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
  isNumberedSeats: boolean;
  isScatteredSeats: boolean;
  isTimeSlot: boolean;
  isShowingEmptyWarning: boolean;
  isShowingCategoryWarning: boolean;
  isMaxNumberOfSeats: boolean;
  maxNumberOfSeats: number;
  selectedSectionID: number;
  selectedSeats: Julius.Website.SeatRequestViewModel[];
  seatTypes: Julius.Website.PerformanceSeatTypeViewModel[];
  allowManualReservation: boolean;
  onSectionSelection: (sectionID: number) => void;
  onSeatSelection: (selection: Julius.Website.SeatRequestViewModel) => void;
  onScatteredSeatsChange: (isChecked: boolean) => void;
  onPickManually: () => void;
  onPickAutomatically: () => void;
}

const PickSeatAutomatic: React.SFC<IProps> = ({
  isNumberedSeats,
  isScatteredSeats,
  isShowingEmptyWarning,
  isShowingCategoryWarning,
  isTimeSlot,
  isMaxNumberOfSeats,
  maxNumberOfSeats,
  selectedSectionID,
  selectedSeats,
  seatTypes,
  onSectionSelection,
  onSeatSelection,
  onScatteredSeatsChange,
  onPickManually,
  onPickAutomatically,
  allowManualReservation,
}) => {

  if (!seatTypes || !seatTypes.length) {
    return (
      <FormattedText
        displayName={ 
          `Vi kunde inte hitta några tillgängliga 
          biljetter... Försök gärna igen om en stund.` 
        }
        formattedName='order.message.noseats'
      />
    );
  }

  const errorComponent = (
    (isShowingCategoryWarning || isShowingEmptyWarning) &&
      <div className='error'>
        <FormattedText 
          style='sub-title medium-bold'
          displayName='Observera'
          formattedName='order.seatpicker.obs'
        />
        { isShowingCategoryWarning &&
          <FormattedText 
            displayName={ 
              `För att hitta bästa plats måste val av 
              priskategori vara samma för alla biljetter.`
            }
            formattedName='order.seatpicker.warning.category'
          />
        }
        { isShowingEmptyWarning &&
          <FormattedText 
            displayName={ 
              `Du måste välja minst en biljett 
              för att kunna gå vidare.`
            }
            formattedName='order.seatpicker.warning.empty'
          />
        }
      </div>
  );

  return (
    <div className='pick-seat-automatic'>
      <FormattedText 
        style='title black'
        displayName='Välj antal biljetter'
        formattedName='order.numberoftickets'
      />
      { isTimeSlot &&
        <PickTime 
          sections={ seatTypes[0].sectionCategories }
          currentSectionID={ selectedSectionID }
          onSelect={ onSectionSelection }
        />
      }
      <Divider />
      <div className='seat-items'>
        { seatTypes.map((seatType, i) =>
          <div key={ i }>
            <SeatItem 
              seatType={ seatType }
              isMaxNumberOfSeats={ isMaxNumberOfSeats }
              maxNumberOfSeatsPromotion={ maxNumberOfSeats }
              currentSelection={ 
                selectedSeats.find(s => 
                  s.discountID === seatType.discountID) 
              }
              onSeatSelection={ onSeatSelection }
            />
            <Divider />
          </div>)
        }
      </div>
      { isNumberedSeats ?
        <div className='button-container'>
          <div className='scattered-seats-input'>
            <Checkbox 
              onChange={ onScatteredSeatsChange } 
              value={ isScatteredSeats }
            >
              <FormattedText
                displayName='Accepterar utspridda platser'
                formattedName='order.scatteredseats'
              />
            </Checkbox>
          </div>
          { allowManualReservation && (
            <Button 
              onClick={ onPickManually }
            >
              <FormattedText 
                displayName='Välj platser manuellt'
                formattedName='order.pickmanually'
              />
            </Button>
          ) }
          <Button onClick={ onPickAutomatically }>
            <FormattedText
              displayName='Hitta bästa plats'
              formattedName='order.pickautomatic'
            />
          </Button>
        </div> :
        <div className='button-container'>
          <Button onClick={ onPickAutomatically }>
            <FormattedText
              displayName='Sök biljetter'
              formattedName='order.searchtickets'
            />
          </Button>
        </div>
      }
      { errorComponent }
    </div>
  ); 
};

export default PickSeatAutomatic;


// WEBPACK FOOTER //
// ./src/components/PickSeatAutomatic/PickSeatAutomatic.tsx